import React from 'react'
import data from './data.json'
import {
  Intro,
  Layout,
  Header,
  SectionTitle,
  Grid,
  GridItem,
} from '../../../../components'

import './style.scss'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        //state="design" disabling switcher
        title={data.title}
      />
      <Layout
        //site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Our voice and tone should reflect M{'&'}T Bank's brand and business
            philosophy, captured in the brand promise{' '}
            <strong>"Understanding what's important."</strong> This phrase
            should be kept in mind when creating content, but only used directly
            in marketing contexts. We should strive to communicate that we’re
            focused on what’s important to our customers, which means we know
            them, understand their needs and work to provide a banking
            experience that supports them. Our content should work to support
            our overall brand characteristics, reinforcing friendlier,
            colloquial, branded language and move away from institutional,
            heavy, overwritten language. Copy should be easy to read, which
            means blocks of text should be made “scannable” by the use of
            subheads, bullets and short paragraphs whenever possible.
          </p>
        </Intro>
        <SectionTitle>Brand Characteristics</SectionTitle>
        <p>
          Where appropriate, content should explicitly or implicitly reinforce
          the characteristics that define M{'&'}T Bank:
        </p>
        <ul class="voice-tone__list">
          <li>
            <strong>Hardworking</strong>
            <p>diligent, devoted, thorough</p>
          </li>
          <li>
            <strong>Reliable</strong>
            <p>trustworthy, consistent, dependable, steadfast</p>
          </li>
          <li>
            <strong>Straighforward</strong>
            <p>sincere, honest, open, genuine</p>
          </li>
          <li>
            <strong>Accessible</strong>
            <p>approachable, amicable, engaging, inviting</p>
          </li>
          <li>
            <strong>Insightful</strong> <p>perceptive, understanding, astute</p>
          </li>
          <li>
            <strong>Caring</strong> <p>community-minded, helpful, supportive</p>
          </li>
          <li>
            <strong>Forward-looking</strong>
            <p>optimistic, active, energetic</p>
          </li>
        </ul>
        <SectionTitle>Voice</SectionTitle>
        <p>
          Our brand voice reflects our distinct personality, style and point of
          view, incorporating all of our brand characteristics. M{'&'}T Bank has
          a strong, established brand that values hard work, community and
          getting it right. The M{'&'}T brand is embodied in content that simply
          and conversationally tells it like it is, rather than dressing up a
          product or service with dry, overly formal or unnecessary corporate
          jargon. Our brand voice speaks plainly, but not so casually as to
          cross over into sounding unprofessional or using slang. It’s a
          comfortable and confident style that is also approachable.
        </p>
        <SectionTitle>Tone</SectionTitle>
        <p>
          Tone influences the way customers feel when interacting with our
          brand. M{'&'}T's credo is that of "pervasive customer service," and
          our content should manifest that. Conten should have the "How can we
          help?" attitude that ultimately achieves the goal of empowering users.
        </p>

        <ul class="voice-tone__tone">
          <h3 className="c-title-3--normal l-margin-bottom--medium">
            Our tone of voice (how we say it) is:
          </h3>
          <li>Friendly</li>
          <li>Conversational</li>
          <li>Informative</li>
          <li>Progressive</li>
          <li>
            Reflective of the empathetic quality inherent in our "understanding"
            brand promise
          </li>
        </ul>

        <hr />
        <SectionTitle>How it Sounds</SectionTitle>
        <Grid>
          <GridItem columns="6">
            <div class="do">
              <div class="do__title">
                <i class="icon icon--success"></i> Friendly, Colloquial Voice
                and Tone
              </div>
              <h3 className="voice-tone__h6">Total Balance</h3>
              <p>
                This is the balance you had at the end of yesterday, plus or
                minus any transactions that process in real time. Any pending
                checks or other transactions are not included here. Refer to
                your Available Balance to see the amount you can access right
                now for withdrawals, transfers and payments.
              </p>
            </div>
          </GridItem>
          <GridItem columns="6">
            <div class="dont">
              <div class="dont__title">
                <i class="icon icon--error"></i> Institutional, Overly Formal
                Voice and Tone
              </div>

              <h3 className="voice-tone__h6">Total Balance</h3>
              <p>
                The previous business day’s ending balance, plus or minus
                certain limited transactions that are processed real-time.
                Balances from pending transactions that have not posted to your
                account may not be reflected. Your total balance also does not
                include checks or other transactions you may have initiated that
                have not yet been presented to the bank for payment. For the
                amount currently available for withdrawals, transfers, and
                payments, please refer to the Available Balance.
              </p>
            </div>
          </GridItem>
        </Grid>
      </Layout>
    </>
  )
}
